module.exports = __webpack_public_path__ + "static/media/pause.ee24e523.png";